import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDialogOpen, setLoggedInUserAccount } from '../../../store/Actions';
import DialogTitle from '@mui/material/DialogTitle';
import { storeUserAccount } from '../../../firebase/Firestore';
import { UploadAvatar } from './UploadAvatar';

export function UploadAccountAvatar() {
    const loggedInUserAccount = useSelector(state=>state.loggedInUserAccount);
    const dialogData = useSelector(state=>state.dialogData)
    const dispatch = useDispatch();

    return (
        <>
            <DialogTitle>{dialogData.dialogTitle}</DialogTitle>
            <UploadAvatar 
                userAccount={loggedInUserAccount}
                setUserAccount={(updatedUserAccount)=>dispatch(setLoggedInUserAccount(updatedUserAccount))}
                storeUserAccount={storeUserAccount}
                onDone={()=>dispatch(setDialogOpen(dialogData.parentDialog))}
                onCancel={()=>dispatch(setDialogOpen(dialogData.parentDialog))}
            />
        </>
    );
}
